import React from 'react'
import PropTypes from 'prop-types'
import { Col } from 'antd'
import './index.less'
import giphyLogo from '/public/img/giphy-1.png'
import { Spinner } from 'components/Spinner'

export const GifsList = ({ selectGif, gifsUrl, fetched }) => {
  return fetched ? (
    <>
      <img
        className='hide-on-sm'
        style={{ margin: '5px 10px' }}
        align='right'
        src={giphyLogo}
      />
      <Col lg={{ span: 12 }} className='hide-on-sm' id='list-container'>
        <div style={{ backgroundColor: 'white', paddingRight: '10px' }}>
          <Col id='gif-list'>
            {gifsUrl.map(gif => (
              <img
                onClick={() => selectGif(gif.original.url)}
                key={gif.fixed_height_small.url}
                src={gif.fixed_height_small.url}
                id='gif'
              />
            ))}
          </Col>
        </div>
      </Col>
    </>
  ) : (
    <div className='hide-on-sm'>
      <Spinner />
    </div>
  )
}
GifsList.propTypes = {
  /** An array of the fetched gifs url */
  gifsUrl: PropTypes.array.isRequired,

  /** Function to be called when the user chooses the gif from the list */
  selectGif: PropTypes.func.isRequired,

  /** Boolean value representing the search status on the giphy api */
  fetched: PropTypes.bool.isRequired,
}
